import React from 'react';
import './style.css';
import {Container,Row,Col,Button } from 'react-bootstrap';
import ReactTypingEffect from 'react-typing-effect';
import { useHistory } from "react-router-dom";

import { aboutUser } from '../../../const/about_user';



function Home_Left() {

  const history = useHistory();

  const changePath  = () => {

    history.push({pathname :"/about"})

  }
  return (
    <Container className="home-left" >
      <Row className="home-left-main">

        <Col xl={12} className="home-left-main-col">
        
          <h1 className="first-line">
            Hello! 
         </h1>
          <h2 className="second_line">
            I am <strong>{aboutUser.fullName}</strong>
          </h2>
          <h3>
            <ReactTypingEffect
              text={aboutUser.workPosition}
              className="typical"
              speed="100"
              eraseDelay="500000"
            />
          </h3>

          <br />
          <div className="home-left-buttons-container">
          <Button variant="outline-light" size="lg" className="home-left-aboutmme-btn" onClick={()=> changePath ()}>See More</Button> &nbsp;
          </div>
        </Col>


      </Row>
    </Container>
  );
}

export default Home_Left;
